import { AxiosClient, Api } from "@/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const logout = createAsyncThunk(
  "auth/logout",
  (): Promise<void> => AxiosClient.post(Api.logout())
);
